<template>
  <div class="px-page mb-8">
    <h2 class="font-semibold text-xl leading-tight">
      Audits | Customs
    </h2>
  </div>

  <div class="card">
    <table class="table">
      <thead>
      <tr>
        <th>Order</th>
        <th class="hidden lg:table-cell">Status</th>
        <th class="hidden sm:table-cell">User</th>
        <th>Happened At</th>
      </tr>
      </thead>
      <tbody>
        <template v-if="audits.data.length" v-for="audit in audits.data">
          <tr>
            <td class="w-full max-w-0 text-gray-900 sm:w-auto sm:max-w-none">
              <a href="#">{{ audit.order_number }}</a>
              <dl class="font-normal lg:hidden">
                <dt class="sr-only">Status</dt>
                <dd class="mt-1 truncate text-gray-700">{{ audit.status }}</dd>
                <dt class="sr-only sm:hidden">User</dt>
                <dd class="mt-1 truncate text-gray-500 sm:hidden">
                  <a href="#">{{ audit.user_name }}</a>
                </dd>
              </dl>
            </td>
            <td class="hidden text-gray-500 lg:table-cell">
              {{ audit.status }}
            </td>
            <td class="hidden text-gray-500 sm:table-cell">
              <a href="#">{{ audit.user_name }}</a>
            </td>
            <td>
              {{ audit.happened_at }}
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="4" class="text-center">No customs audits recorded</td>
          </tr>
        </template>
      </tbody>
    </table>

    <div class="card-footer">
      <Pagination v-bind:pagination="pagination" />
    </div>
  </div>
</template>

<script setup>
import Pagination from "../../components/Pagination";

const { audits } = defineProps(['audits']);
const pagination = Object.assign({}, audits);
delete pagination.data;
</script>
